'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.default = colorFunc;

var _d3Scale = require('d3-scale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schemeMap = {
    'category10': _d3Scale.schemeCategory10,
    'category20': _d3Scale.schemeCategory20,
    'category20b': _d3Scale.schemeCategory20b,
    'category20c': _d3Scale.schemeCategory20c
};

function colorFunc(colors) {
    if ((0, _isFunction3.default)(colors)) {
        return colors;
    } else if ((0, _isEmpty3.default)(colors)) {
        return (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory20);
    } else if ((0, _isString3.default)(colors)) {
        return (0, _d3Scale.scaleOrdinal)(schemeMap[colors]);
    } else {
        return (0, _d3Scale.scaleOrdinal)(colors);
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/colorFunc.js
// module id = 124
// module chunks = 0